import { render, staticRenderFns } from "./accept-table-custom.vue?vue&type=template&id=e2376208&scoped=true&"
import script from "./accept-table-custom.vue?vue&type=script&lang=ts&"
export * from "./accept-table-custom.vue?vue&type=script&lang=ts&"
import style0 from "./accept-table-custom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./accept-table-custom.vue?vue&type=style&index=1&id=e2376208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2376208",
  null
  
)

export default component.exports